import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <p className="text-6xl font-bold text-muted-foreground/30 mb-4">404</p>
        <p className="text-foreground font-semibold mb-2">Página não encontrada</p>
        <p className="text-muted-foreground text-sm mb-6">A página que procura não existe.</p>
        <Button asChild variant="outline">
          <Link to="/"><ArrowLeft size={15} className="mr-2" />Voltar ao início</Link>
        </Button>
      </div>
    </div>
  );
}
